import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

export const URL = `${APIConfiguration.owner}owners/forOrder/${COMMON_QUERY_PARAMS.ORDER_ID}`;

export interface CreateOwnerForOrderCommandArgs {
  orderId: string;
}

export const createOwnerForOrderRequest = (
  payload: CreateOwnerForOrderCommandArgs,
): ApiRequestDescriptor => ({
  url: URL.replace(COMMON_QUERY_PARAMS.ORDER_ID, payload.orderId),
  config: { method: SUPPORTED_METHODS.POST, json: {} },
});

export async function createOwnerForOrderCommand(
  payload: CreateOwnerForOrderCommandArgs,
): Promise<BackResponse<string> | BackResponseFailure> {
  try {
    return await executeQuery<BackResponse<string>>(
      createOwnerForOrderRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
